import {
  anAddSignalsToInsight,
  aSignal,
  mockAddSignalsMutationOperationMutation,
  mockAddSignalsToInsightOperationMutation,
  SignalFragment,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockAddSignalsToInsightOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          addSignalsToInsight: anAddSignalsToInsight(),
        },
      });
    }
  ),
  mockAddSignalsMutationOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          addSignalsToInsight: {
            ...anAddSignalsToInsight(),
            data: {
              ...anAddSignalsToInsight().data,
              signals: [aSignal() as SignalFragment],
              relatedSignals: [aSignal() as SignalFragment],
            },
          },
        },
      });
    }
  ),
];
